/* This file was generated automatically. Do not edit manually. */

export enum PaymentState {
    Charged = 'Charged',
    Canceled = 'Canceled',
    Pending = 'Pending',
    Failed = 'Failed',
    Verifying = 'Verifying',
}
